import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Chart, registerables } from "chart.js";

@Component({
  selector: "app-user-list-bar-chart",
  templateUrl: "./bar-chart.component.html",
  styleUrls: ["./bar-chart.component.css"],
})
export class BarChartComponent {
  @Input() labels;
  @Input() data;

  @Output() selectedUser = new EventEmitter<any>();

  myChart: any;
  constructor() {
    Chart.register(...registerables);
  }

  ngAfterViewInit() {
    this.createChart([], []);
  }

  ngOnChanges() {
    if (this.myChart) {
      this.myChart.destroy();
      this.createChart(this.labels, this.data);
    }
  }

  createChart(labels, data) {
    this.myChart = new Chart("canvas", {
      type: "bar",
      data: {
        labels: labels,
        datasets: [
          {
            // label: "number of applications related to",
            data: data,
            backgroundColor: "rgba(54, 162, 235, 0.2",
            borderColor: "rgba(54, 162, 235, 1)",
            borderWidth: 1,
          },
        ],
      },
      options: {
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            title: { display: true, text: "No. of Requests" },
            beginAtZero: true,
          },
        },
        onClick: (event, array) => {
          this.timeSlotEdit(event, array);
        },
      },
    });
  }

  timeSlotEdit(event, array) {
    const points = this.myChart.getElementsAtEventForMode(
      event,
      "nearest",
      { intersect: true },
      true
    );
    if (points.length) {
      const firstPoint = points[0];
      let label = this.myChart.data.labels[firstPoint.index];
      this.selectedUser.emit(label);
    }
  }
}
